import type { ReactElement } from 'react';
import { screens as home } from '@/features/home/screens';
import { screens as manage } from '@/features/manage/screens';
import { screens as settings } from '@/features/settings/screens';
import { screens as settingsB } from '@/features/settings-b/screens';
import { screens as trCore } from '@/features/tr-core/screens';
import { screens as trReports } from '@/features/tr-reports/screens';
import { screens as trMgmt } from '@/features/tr-mgmt/screens';
import { screens as trNotes } from '@/features/tr-notes/screens';
import { screens as trReportSettings } from '@/features/tr-reportsettings/screens';
import { screens as trWorkflow } from '@/features/tr-workflow/screens';
import { screens as trWorkflow2 } from '@/features/tr-workflow2/screens';
import { screens as trLeaf } from '@/features/tr-leaf/screens';

/**
 * Every ported screen, keyed by its Angular URL. Each slice owns its own registry file, so slices never touch this
 * file. Anything missing renders the NotMigrated placeholder; the cutover gate is an empty placeholder list.
 */
export const screens: Record<string, ReactElement> = {
  ...home,
  ...manage,
  ...settings,
  ...settingsB,
  ...trCore,
  ...trReports,
  ...trMgmt,
  ...trNotes,
  ...trReportSettings,
  ...trWorkflow,
  ...trWorkflow2,
  ...trLeaf,
};
